import { Currency, InvoiceCurrency } from '@app/core/models/customer.models';

export class SetUserCurrency {
  static type = '[Customer] set user currency';

  constructor(
    readonly value: Currency,
    readonly persist?: boolean,
  ) {}
}

export class GetCustomerCurrencyRate {
  static type = '[Customer] Get Customer Currency Rate';
  constructor() {}
}

export class SetMetricCurrency {
  static type = '[Customer] set metric currency';

  constructor(readonly value: Currency) {}
}

export class SetSubscriptionCurrency {
  static type = '[Customer] set subscription currency';

  constructor(readonly value: InvoiceCurrency) {}
}
